import { __awaiter } from "tslib";
import Time from 'date-and-time';
import { Container, Service } from './container';
import { Config } from './config';
import { Checkout } from './checkout';
import { AUTH_STORAGE_FLAGS, SessionManager } from './session-manager';
import { Backend } from './backend';
import { AppState } from '../etc/stores';
import sessionKeys from '../etc/sessionKeys';
const WOOCOMMERCE_CONNECTING_ACCOUNT = 'woocommerce_connecting_account';
const WOOCOMMERCE_GUEST_ID = '0';
export class Woocommerce extends Service {
    constructor() {
        super(...arguments);
        this.config = this.ctx.get(Config);
        this.checkout = this.ctx.get(Checkout);
        this.backend = this.ctx.get(Backend);
        this.session = this.ctx.get(SessionManager);
    }
    getCurrentMember() {
        return __awaiter(this, void 0, void 0, function* () {
            if (window['twismExternalUserId'] !== WOOCOMMERCE_GUEST_ID) {
                return window['twismExternalUserId'];
            }
            return null;
        });
    }
    getAuthState() {
        return __awaiter(this, void 0, void 0, function* () {
            const { account } = yield this.config.getSiteSettings();
            const userId = yield this.getCurrentMember();
            let token = null;
            if (userId) {
                const localToken = this.session.get(sessionKeys.TOKEN);
                const response = localToken ||
                    (yield this.backend.customerConnectAuthenticate({
                        customerId: parseInt(userId)
                    }, 'woocommerce'));
                token = response.token;
            }
            if (token) {
                this.session.set(sessionKeys.TOKEN, { token });
            }
            else {
                this.session.remove(sessionKeys.TOKEN);
                AppState.update(state => (Object.assign(Object.assign({}, state), { auth: Object.assign(Object.assign({}, state.auth), { connected: false, access_token: undefined }) })));
            }
            return {
                token,
                userId: userId === null || userId === void 0 ? void 0 : userId.toString(),
                provider: 'woocommerce',
                account
            };
        });
    }
    registerWebsiteEvents() {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            const checkoutRegex = /^.*?\bcheckout\b.*?\border-received\b.*?$/;
            const currentPathName = window['location'].pathname;
            const { orderUser, orderData } = window['twism_data'];
            const { account } = this.config.getSiteSettings();
            if (this.isCurrentRemindCodePage()) {
                const checkoutValue = Number((document.querySelector('.woocommerce-Price-amount') || {
                    textContent: '0'
                }).textContent.replace(/[^0-9.-]+/g, ''));
                this.session.set(sessionKeys.CHECKOUT_VALUE, checkoutValue, {
                    expires: Time.addDays(new Date(), 1)
                });
            }
            if (currentPathName.match(checkoutRegex) && (orderData === null || orderData === void 0 ? void 0 : orderData.id)) {
                const authInit = yield this.getAuthState();
                yield this.backend.authenticate(authInit);
                const total = Math.trunc(parseFloat(orderData.total) * 100);
                const shippingFee = Math.trunc(parseFloat(orderData.shipping_total) * 100);
                const totalTax = Math.trunc(parseFloat(orderData.total_tax) * 100);
                this.checkout.handleCheckout({
                    transactionId: (_a = orderData === null || orderData === void 0 ? void 0 : orderData.id) === null || _a === void 0 ? void 0 : _a.toString(),
                    externalTransactionId: (_b = orderData === null || orderData === void 0 ? void 0 : orderData.id) === null || _b === void 0 ? void 0 : _b.toString(),
                    account,
                    currency: orderData === null || orderData === void 0 ? void 0 : orderData.currency,
                    externalCustomerId: orderUser && orderUser.ID !== 0 ? (_c = orderUser === null || orderUser === void 0 ? void 0 : orderUser.ID) === null || _c === void 0 ? void 0 : _c.toString() : null,
                    value: total - shippingFee - totalTax,
                    externalCustomerEmail: (orderUser === null || orderUser === void 0 ? void 0 : orderUser.user_email) || ((_d = orderData === null || orderData === void 0 ? void 0 : orderData.billing) === null || _d === void 0 ? void 0 : _d.email),
                    externalCustomerFirstName: (orderUser === null || orderUser === void 0 ? void 0 : orderUser.user_nicename) || ((_e = orderData === null || orderData === void 0 ? void 0 : orderData.billing) === null || _e === void 0 ? void 0 : _e.first_name),
                    externalCustomerLastName: (_f = orderData === null || orderData === void 0 ? void 0 : orderData.billing) === null || _f === void 0 ? void 0 : _f.last_name
                });
            }
            if ((yield this.getCurrentMember()) &&
                this.session.get(WOOCOMMERCE_CONNECTING_ACCOUNT)) {
                this.session.remove(WOOCOMMERCE_CONNECTING_ACCOUNT);
                const getData = () => __awaiter(this, void 0, void 0, function* () {
                    if (this.session.get(AUTH_STORAGE_FLAGS.referral)) {
                        const searchParams = new URLSearchParams(this.session.get(AUTH_STORAGE_FLAGS.referral));
                        const campaign = searchParams.get('twism-campaign') || searchParams.get('campaign');
                        const linkId = searchParams.get('twism-linkId') || searchParams.get('LinkId');
                        if (campaign === 'business-referral' && linkId) {
                            const referralReferredState = yield this.backend.getReferralByLinkId(linkId);
                            AppState.update(state => (Object.assign(Object.assign({}, state), { referralReferredState })));
                        }
                        return {
                            category: 'referredCoin',
                            authFlow: 'referred-redeem'
                        };
                    }
                    if (this.session.get(AUTH_STORAGE_FLAGS.customerImport)) {
                        return {
                            authFlow: 'customer-import',
                            popoverOpen: true,
                            popoverRouteOnOpen: {
                                route: '/customer-import-welcome'
                            }
                        };
                    }
                    if (this.session.get(AUTH_STORAGE_FLAGS.customerAcquisition)) {
                        return {
                            authFlow: 'customer-acquisition',
                            popoverOpen: true,
                            popoverRouteOnOpen: {
                                route: '/customer-acquisition'
                            }
                        };
                    }
                    if (this.session.get(AUTH_STORAGE_FLAGS.welcomeCoins)) {
                        return {
                            category: 'welcomeCoinAvailable',
                            authFlow: 'free-coins'
                        };
                    }
                    if (this.session.get(AUTH_STORAGE_FLAGS.fastRedemption)) {
                        return {
                            category: 'fastRedemption',
                            authFlow: 'fast-redemption'
                        };
                    }
                    return {
                        popoverOpen: true
                    };
                });
                const flow = yield getData();
                AppState.update(state => (Object.assign(Object.assign({}, state), { website: Object.assign(Object.assign(Object.assign({}, state.website), flow), { connectingAccount: true }) })));
            }
        });
    }
    isConnectingAccount() {
        return this.session.get(WOOCOMMERCE_CONNECTING_ACCOUNT);
    }
    isCurrentCartPage() {
        return window.location.href.includes('/cart');
    }
    isCurrentRemindCodePage() {
        return window.location.href.includes('/checkout');
    }
    getCheckoutInformation() {
        return __awaiter(this, void 0, void 0, function* () {
            const checkoutUser = window['twismOrderUser'];
            const orderId = window['twismOrderId'];
            if (!checkoutUser || !orderId)
                return null;
            const [firstName, lastName] = checkoutUser.display_name;
            return {
                orderId: orderId.toString(),
                email: checkoutUser.email,
                firstName,
                lastName,
                phone: null
            };
        });
    }
    openLoginModal() {
        this.session.set(WOOCOMMERCE_CONNECTING_ACCOUNT, true);
        window.location.href = '/my-account/';
    }
}
Container.add(Woocommerce);
